import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BASE_URL_USER}/azure-ad`;

export const getAllUsersFromAzureAD = async (search, cancelToken) => {
  const response = await axios.get(
    `${baseUrl}?filter=${search}`,
    { cancelToken: cancelToken.token }
  );
  return response;
};
